export default __webpack_public_path__ + "curve-section-bottom.d71e0b.svg";